var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',[_c('router-view')],1),(_vm.showLoading)?_c('div',{staticClass:"loading-app"},[_vm._m(0)]):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-box"},[_c('img',{attrs:{"src":"/assets/loading.png","alt":""}})])
}]

export { render, staticRenderFns }